import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CopyrightNotice from '../components/CopyrightNotice';
import { sanitizeHtml } from '../lib/sanitize';
import api from '../lib/api';

const CopyrightPolicy = () => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/legal/copyright').then((r) => setPage(r.data)).catch(() => setPage(null)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="App" data-testid="page-copyright-policy">
      <Header />
      <main className="bg-cream min-h-screen">
        <section className="max-w-[860px] mx-auto px-6 lg:px-10 py-16">
          <div className="eyebrow mb-3">Legal</div>
          <h1 className="font-serif-display text-4xl md:text-5xl text-burgundy">
            {page?.title || 'Copyright & DMCA Policy'}
          </h1>
          {page?.updated_at && (
            <p className="mt-2 text-sm text-mahogany/60">Last updated {new Date(page.updated_at).toLocaleDateString()}</p>
          )}

          {loading ? (
            <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 animate-spin text-mahogany" /></div>
          ) : page?.content ? (
            <div className="prose-osho mt-8 text-mahogany/90" data-testid="copyright-policy-content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.content) }} />
          ) : (
            <div className="mt-8"><CopyrightNotice showPolicyLink={false} /></div>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CopyrightPolicy;
